import React, { useCallback, useEffect } from 'react';
import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';
import { FormikValues } from 'formik';

interface IProps {
  label: string;
  name: string;
  formik: FormikValues;
  defaultValue?: boolean;
  disabled?: boolean;
}

const Checkbox: React.FC<IProps> = ({
  label = '',
  name,
  formik,
  defaultValue = false,
  disabled = false,
}) => {
  const handleCheckbox = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue(name, event.target.checked);
  }, []);

  useEffect(() => {
    formik.setFieldValue(name, defaultValue);
  }, []);

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          checked={formik.values[name]}
          onChange={handleCheckbox}
          name={name}
          id={name}
          disabled={disabled}
        />
      }
      label={<b>{label}</b>}
      labelPlacement="start"
      style={{ marginLeft: '0px' }}
    />
  );
};

export default Checkbox;
